import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import UserManagementList from "./UserManagementList";
import UserEdit from "./UserEdit";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function UserManagement() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ADMIN_LEGAL_DEPOSITS] },
                React.createElement(UserManagementList, null))); } }),
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/:id/edit"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ADMIN_LEGAL_DEPOSITS] },
                React.createElement(UserEdit, null))); } })));
}
export default UserManagement;
